const LETTER = '(?:الف|[A-Fa-f1-6أإابجدهو])';
const OPTION_RE = new RegExp(`^${LETTER}\\s*[.)\\-:،]\\s*(.+)$`);
const Q_WORDS = 'fråga|frågan|question|السؤال|سؤال|سوال|سؤال|soru|su\'aal|su’aal|suaal|su\'aalka|pytanie|pregunta|frage';
const C_WORDS = 'rätt svar|rätt alternativ|correct answer|right answer|answer|الإجابة الصحيحة|الاجابة الصحيحة|الإجابة|الجواب الصحيح|الجواب|doğru cevap|doğru yanıt|cevap|پاسخ صحیح|پاسخ درست|جواب صحیح|جواب درست|گزینه صحیح|گزینه درست|پاسخ|jawaabta saxda ah|jawaabta saxda|jawaabta|jawaab sax|prawidłowa odpowiedź|poprawna odpowiedź|odpowiedź|respuesta correcta|respuesta|richtige antwort|korrekte antwort|antwort|lösung';
const E_WORDS = 'förklaring|explanation|الشرح|شرح|التوضيح|التفسير|açıklama|توضیح|توضیحات|شرح پاسخ|sharaxaad|sharaxaadda|faahfaahin|wyjaśnienie|explicación|erklärung|begründung';
const QUESTION_LABEL = new RegExp(`^(${Q_WORDS})\\s*\\d*\\s*[:：]\\s*`, 'i');
const CORRECT_LABEL = new RegExp(`^(${C_WORDS})\\s*[:：]\\s*(.*)$`, 'i');
const EXPL_LABEL = new RegExp(`^(${E_WORDS})\\s*(?:[:：]\\s*(.*))?$`, 'i');
const FIND_LETTER = new RegExp(`(?:^|[\\s:(])(${LETTER})(?=[\\s.):✅✔]|$)`);
const AR = ['أ', 'ب', 'ج', 'د', 'ه', 'و'];

const clean = (l) => l.replace(/\\([\\`*_{}[\]()#+\-.!?|>~])/g, '$1').replace(/\s*\\+\s*$/, '').replace(/\*\*|__|`/g, '').replace(/^[#>•\s]+/, '').trim();

const letterIndex = (raw) => {
  if (raw === 'الف' || raw === 'ا' || raw === 'إ') return 0;
  if (/[A-Fa-f]/.test(raw)) return raw.toUpperCase().charCodeAt(0) - 65;
  if (/[1-6]/.test(raw)) return Number(raw) - 1;
  const i = AR.indexOf(raw);
  return i >= 0 ? i : null;
};

const stripLinks = (t) => t
  .replace(/\s*\[[^\]]*\]\(\s*https?:\/\/[^)]*\)/g, '')
  .replace(/\s*\(?\s*https?:\/\/[^\s)]+\)?/g, '');

export const parseQuestionText = (text) => {
  const lines = stripLinks(text).split(/\r?\n/).map(clean);
  const q = [], options = [], expl = [];
  let correct = null, stage = 'q', seenExpl = false;
  for (const line of lines) {
    if (!line) { if (stage === 'e' && expl.length) expl.push(''); else if (stage === 'q' && q.length) q.push(''); continue; }
    const isOpt = OPTION_RE.test(line);
    const c = !isOpt && line.match(CORRECT_LABEL);
    if (c && stage !== 'q') {
      const m = c[2].match(FIND_LETTER);
      if (m) correct = letterIndex(m[1]);
      stage = 'e';
      continue;
    }
    if (stage === 'o' && !isOpt && /✅|✔/.test(line)) {
      const m = line.match(FIND_LETTER);
      if (m) correct = letterIndex(m[1]);
      stage = 'e';
      continue;
    }
    const e = !isOpt && !seenExpl && line.match(EXPL_LABEL);
    if (e && stage !== 'q') { stage = 'e'; seenExpl = true; if (e[2]) expl.push(e[2]); continue; }
    const o = stage !== 'e' && line.match(OPTION_RE);
    if (o) {
      stage = 'o';
      if (/✅|✔/.test(o[1])) correct = options.length;
      options.push(o[1].replace(/[✅✔️]+/g, '').trim());
      continue;
    }
    if (stage === 'q') {
      const t = line.replace(QUESTION_LABEL, '');
      if (t && !(q.length === 0 && /^[^\s:]{1,20}\s*[:：]$/.test(t))) q.push(t);
    } else expl.push(line);
  }
  return { question: q.join('\n').replace(/\n{3,}/g, '\n\n').trim(), options, explanation: expl.join('\n').replace(/\n{3,}/g, '\n\n').trim(), correct: correct !== null && correct < options.length ? correct : null };
};
